var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1877 14.1406C15.1521 12.3623 16.3202 9.81983 16.8311 6.33455C18.582 11.5359 22.964 15.5814 28.4475 17.024C22.6793 18.5417 18.1299 22.9389 16.5799 28.5326C15.1004 23.193 10.8865 18.9432 5.48871 17.2481C8.73627 16.7948 11.2989 15.8505 13.1877 14.1406Z",
    stroke: "#E7D6AF",
    strokeWidth: 1.11289
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1177 16.8522C16.3858 16.6424 16.5927 16.3905 16.7478 16.0997C17.0503 16.4693 17.4335 16.7824 17.8706 17.0243C17.3491 17.313 16.9043 17.7029 16.5817 18.1693C16.3155 17.7844 15.966 17.4516 15.5589 17.1848C15.7617 17.0943 15.9485 16.9846 16.1177 16.8522Z",
    fill: "#E7D6AF",
    stroke: "#E7D6AF",
    strokeWidth: 1.11289
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.71d15b605b424c28246309ca245dcc07.svg";
export { ForwardRef as ReactComponent };